import axios from 'axios';

const api = axios.create({ baseURL: process.env.VUE_APP_API_HOST });

api.interceptors.request.use((config) => {
  if (!config.headers) {
    config.headers = {};
  }
  const hasAuth = config.headers.Authorization || config.headers.authorization;
  if (!hasAuth) {
    try {
      const tokenString = sessionStorage.getItem('auth:token');
      if (tokenString && tokenString !== 'undefined' && tokenString !== 'null') {
        const tokenObj = JSON.parse(tokenString);
        const token = tokenObj?.token || tokenObj;
        if (token) {
          config.headers.Authorization = `Bearer ${token}`;
        }
      }
    } catch (e) {
      console.error('Erro ao recuperar token no interceptor da API:', e);
    }
  }
  return config;
}, (error) => Promise.reject(error));

export default api;

export function apiSetToken(token) {
  api.defaults.headers.Authorization = token ? `Bearer ${token}` : null;
}

export function setupApiOnResponseError(responseInterceptor) {
  api.interceptors.response.use(null, responseInterceptor);
}

export async function setupBaseURL() {
  if (process.env.NODE_ENV !== 'production') return;
  const { data } = await axios.get('/api-base-url');
  api.defaults.baseURL = data;
}
